import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { MessageInstance } from "antd/es/message/interface";
import type { NotificationInstance } from "antd/es/notification/interface";
import type { HookAPI } from "antd/es/modal/useModal";

export interface AppFeedbackState {
  message: MessageInstance | null;
  notification: NotificationInstance | null;
  modal: HookAPI | undefined;
}

const initialState: AppFeedbackState = {
  message: null,
  notification: null,
  modal: undefined,
};

export const appFeedbackSlice = createSlice({
  name: "appFeedback",
  initialState,
  reducers: {
    setAppFeedbackControls: (state, action: PayloadAction<AppFeedbackState>) => {
      const { message, modal, notification } = action.payload;
      state.message = message;
      state.modal = modal;
      state.notification = notification;
    },
  },
});

export const actions = appFeedbackSlice.actions;

export const appFeedbackReducer = appFeedbackSlice.reducer;
export default appFeedbackReducer;
